import { useMemo } from 'react';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import type { GoToTest } from '../types';
import { CellContainer, CellTypography } from '../components/Flows.styles';

const columnsAdditionalOptions = {
  disableColumnFilter: true,
  disableColumnMenu: true,
};

export const useGoToTestColumns = (): GridColDef[] => {
  return useMemo(
    () => [
      {
        field: 'name',
        headerName: 'Flow name',
        width: 400,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as GoToTest)?.flow?.name ?? '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'app',
        headerName: 'Project',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as GoToTest).app.toUpperCase()}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'flow.url',
        headerName: 'URL',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as GoToTest)?.flow?.url ?? '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'call_to_action',
        headerName: 'Call to action',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as GoToTest)?.flow?.call_to_action ?? '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'flow.default_text.text',
        headerName: 'Default text',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as GoToTest)?.flow?.default_text?.text ?? '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'flow.default_text.language',
        headerName: 'Language',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as GoToTest)?.flow?.default_text?.language ?? '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
    ],
    [],
  );
};
